import React, { useState } from "react";
import { Form, Button, Input, message, Modal, Select } from "antd";
import { useTranslation } from "react-i18next";
import { DownOutlined } from "@ant-design/icons";
import { apiClient } from "../../../shared/api/AllApi";

import "../../../shared/styles/AddProducts.css";

const AddCategory = () => {
  const [form1] = Form.useForm();
  const { t } = useTranslation();
  const [isModalOpenNew, setIsModalOpenNew] = useState(false);

  const handleCancelNew = () => {
    setIsModalOpenNew(false);
  };
  const showModalNew = () => {
    setIsModalOpenNew(true);
  };

  const handleOkNew = () => {
    form1.validateFields(['kurdish', 'arabic'])
      .then(() => {
        setIsModalOpenNew(false);
      })
      .catch(error => {
        console.error("Validation failed:", error);
      });
  };  

  const onFinish = async (values) => {
    try {
      const { kurdish, arabic, description, status } = values;
      
      const formData = new FormData();
      formData.append(
        "name",
        JSON.stringify({
          en: kurdish,
          ar: arabic,
        })
      );
      
      if (description) {
        formData.append("description", description);
      }
      
      formData.append("status", status || 'active');

      const config = {
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      };

      await apiClient.post('/categories', formData, config);
      message.success(t("Category added successfully"));
      window.location.href = "/categories";
    } catch (error) {
      console.error("Error:", error);
      message.error(t("Failed to add category. Please try again later."));
    }
  };

  const onFinishFailed = (errorInfo) => {
    message.error(t("Please fill in all required fields"));
  };

  const handleResetCart = () => {
    form1.resetFields();
  };

  const layout = {
    labelCol: {
      span: 4,
    },
    wrapperCol: {
      span: 16,
    },
  };

  return (
    <div style={{ textAlign: "center", marginTop: "50px", direction: "rtl" }}>
      <h1 style={{ fontSize: "24px", marginBottom: "20px" }}>
        {t("add category")}
      </h1>
      <Form
        form={form1}
        {...layout}
        style={{
          fontSize: "18px"
        }}
        labelCol={{ span: 6 }}
        wrapperCol={{ span: 16 }}
        onFinish={onFinish}
        onFinishFailed={onFinishFailed}
        initialValues={{
          status: "active"
        }}
      >
        <Form.Item label={t("name")}>
          <Button
            type="text"
            style={{
              border: "1px solid #ccc",
              borderRadius: "4px",
              width: "70%",
              fontSize: "16px",
              textAlign: "center",
              display: "inline-block",
              backgroundColor: "#f0f0f0",
              color: "#333",
              fontWeight: "bold",
              boxShadow: "2px 2px 4px rgba(0, 0, 0, 0.1)",
            }}
            onClick={showModalNew}
          >
            <div
              style={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              {form1.getFieldValue('kurdish') && form1.getFieldValue('arabic')
                ? `${form1.getFieldValue('kurdish')} / ${form1.getFieldValue('arabic')}`
                : t("enter category")}
              <DownOutlined />
            </div>
          </Button>          <Modal
            style={{
              direction: "rtl",
            }}
            title={t("enter category")}
            open={isModalOpenNew}
            onOk={handleOkNew}
            onCancel={handleCancelNew}
          >
              <Form.Item
                name="kurdish"
                label={t("كوردى")}
                rules={[{ required: true, message: t('Please enter Kurdish name') }]}
              >
                <Input />
              </Form.Item>
              <Form.Item
                name="arabic"
                label={t("عربي")}
                rules={[{ required: true, message: t('Please enter Arabic name') }]}
              >
                <Input />
              </Form.Item>
          </Modal>
        </Form.Item>

        <Form.Item name="description" label={t("Description")}>
          <Input.TextArea
            style={{ width: "70%", fontSize: "16px" }}
            placeholder={t("Enter description")}
          />
        </Form.Item>

        <Form.Item 
          name="status" 
          label={t("Status")}
          rules={[{ required: true, message: t('Please select a status') }]}
        >
          <Select
            style={{ width: "70%", fontSize: "16px", textAlign: "center" }}
            placeholder={t("Select status")}
          >
            <Select.Option value="active">{t("Active")}</Select.Option>
            <Select.Option value="inactive">{t("Inactive")}</Select.Option>
          </Select>
        </Form.Item>

        <Form.Item label=".">
          <Button
            type="primary"
            style={{
              backgroundColor: "green",
              borderColor: "green",
              fontSize: "16px",
            }}
            htmlType="submit"
          >
            {t("Submit")}
          </Button>
          &nbsp; &nbsp;
          <Button
            type="primary"
            style={{
              backgroundColor: "red",
              borderColor: "red",
              fontSize: "16px",
            }}
            htmlType="button"
            onClick={handleResetCart}
          >
            {t("Reset")}
          </Button>
        </Form.Item>
      </Form>
    </div>
  );
};

export default AddCategory;
